import React from "react";
import "./mintPotato.css";

const MintPotato = () => {
  return (
    <div className="mint-potato">
      <h1 className="mint-a-potato-title">MINT A POTATO</h1>
      <h3 className="total-mints-text">0 / 10,000 MINTS</h3>
      {/* Minting Input Box Start */}
      <div className="minting-input-box">
        <div className="circle-btn">
          <span>-</span>
        </div>
        <div className="value-box">01</div>
        <div className="circle-btn">
          <span>+</span>
        </div>
      </div>
      {/* Minting Input Box End */}
      {/* Mint Now Button Start */}
      <div className="mint-now-btn">
        <span>MINT NOW</span>
      </div>
      {/* Mint Now Button End */}
    </div>
  );
};

export default MintPotato;
